import { createListView, FilterType, ListViewColumnType } from '../../UI/view/list-view';
import { gasCustomerStore, liquidCustomerStore, dewarCustomerStore } from '../../../store/store';
import { gasCustomerList } from '../Customers/customer-gas-list';
import { liquidCustomerList } from '../Customers/customer-liquid-list';
import { dewarCustomerList } from '../Customers/customer-dewar-list';
import { applyCustomerDefaultsFor } from './orders-customer-defaults';
import { OrderType } from './orders-types';

// Single-select variants of the shared customer-list datagrids (same picker used
// on the Misc Billing create screen). Rendered inside the customer-select modal
// (orders-customer-picker-widget.tsx); the widget supplies onSelection so it can
// also close the modal. One picker per order type (Gas/Liquid/Dewar).
const radioColumn = {
  type: ListViewColumnType.radio,
  accessor: 'checked',
  excludeGlobalFilter: true,
  disableFilters: true,
};

// Searchable City filter added to the picker popups (data-derived, like State).
const cityFilter = {
  type: FilterType.combo,
  label: 'City',
  fieldName: 'city',
  searchable: true,
};

export const OrderGasCustomerPicker = createListView({
  ...gasCustomerList,
  toolbar: undefined,
  create: undefined,
  viewOptions: undefined,
  enableExport: false,
  noGlobalFilterPadding: true,
  perColumnFiltering: true,
  selectionMode: 'single',
  filters: [...(gasCustomerList.filters ?? []), cityFilter],
  columns: [radioColumn, ...gasCustomerList.columns],
}, gasCustomerStore as any);

export const OrderLiquidCustomerPicker = createListView({
  ...liquidCustomerList,
  toolbar: undefined,
  create: undefined,
  viewOptions: undefined,
  enableExport: false,
  noGlobalFilterPadding: true,
  perColumnFiltering: true,
  selectionMode: 'single',
  filters: [...(liquidCustomerList.filters ?? []), cityFilter],
  columns: [radioColumn, ...liquidCustomerList.columns],
}, liquidCustomerStore as any);

export const OrderDewarCustomerPicker = createListView({
  ...dewarCustomerList,
  toolbar: undefined,
  noGlobalFilterPadding: true,
  perColumnFiltering: true,
  selectionMode: 'single',
  filters: [...(dewarCustomerList.filters ?? []), cityFilter],
  columns: [radioColumn, ...dewarCustomerList.columns],
}, dewarCustomerStore as any);

export const pickerListFor = (orderTypeId: number) =>
  orderTypeId === OrderType.Gas ? OrderGasCustomerPicker
    : orderTypeId === OrderType.Dewar ? OrderDewarCustomerPicker
      : OrderLiquidCustomerPicker;

// Apply a selected customer row onto the order: id + display name + the
// customer's default field values (legacy SetCustomerInfo).
export const applyCustomerSelection = async (orderTypeId: number, sel: any, setValue: any) => {
  if (!sel?.length || !setValue) return;
  const c = sel[0];
  if (orderTypeId === OrderType.Dewar) {
    // Orders.CustomerId for Dewar is the numeric SiteCustomerId (the dewar list
    // is keyed by the Site string), so bind that, not the pk.
    const cid = c.siteCustomerId ?? c.customerId ?? c.site;
    setValue('customerId', cid, { shouldValidate: true, shouldDirty: true });
    setValue('customerName', c.accountName);
    await applyCustomerDefaultsFor(OrderType.Dewar, cid, setValue);
  } else {
    setValue('customerId', c.customerId, { shouldValidate: true, shouldDirty: true });
    setValue('customerName', c.customerName);
    await applyCustomerDefaultsFor(orderTypeId, c.customerId, setValue);
  }
};
